import React from "react";

export const ActionCard = ({ onOpenModal }) => {
	const handleOpenModal = () => {
		onOpenModal(true);
	};

	return (
		<div className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
			<h5 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Amplify your music's reach and gain new fans</h5>
			<br />
			<div className="items-center justify-center space-y-4 sm:flex sm:space-y-0 sm:space-x-4 rtl:space-x-reverse">
				<button
					onClick={handleOpenModal}
					type="button"
					className="border text-green-400 hover:text-teal-700 border-green-400 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Add Your First Music Label
				</button>
			</div>
			<br />
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				<span className="text-transparent font-bold bg-clip-text bg-gradient-to-r to-green-400 from-teal-700">PRO TIP</span>: Ask{" "}
				<strong>Ava</strong> for assistance with finding new labels for your specific genre of music.
			</p>
		</div>
	);
};
